import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AnalyticsCampaign } from 'src/app/models/AnalyticsCampaign';
import { AnalyticsSequence } from 'src/app/models/AnalyticsSequence';
import { environment } from 'src/environments/environment';
import { PaginatedResult } from 'src/app/shared/model/paginated-result';
import {AnalyticsSales} from '../../models/AnalyticsSales';
import {FunnelPerformanceResponse} from '../../models/FunnelPerformance';
import {FunnelSequencePerformanceItem} from '../../models/FunnelSequencePerformance';
import {map, take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(
    private http: HttpClient
  ) {}

  getCampaigns(campaingName: string, fromAt: string, toAt: string, integrationId: string): Observable<PaginatedResult<AnalyticsCampaign[]>> {
    let endpoint = `${environment.apiUrl}/analytics/campaigns?`;

    if (campaingName) {
      endpoint += `&name=${encodeURIComponent(campaingName)}`;
    }

    if (integrationId) {
      endpoint += `&integration_id=${integrationId}`;
    }

    if (fromAt) {
      endpoint += `&from=${fromAt}`;
    }

    if (toAt) {
      endpoint += `&to=${toAt}`;
    }

    return this.http.get<PaginatedResult<AnalyticsCampaign[]>>(endpoint).pipe(take(1));
  }

  getSequences(campaignId: string, fromAt: string, toAt: string): Observable<PaginatedResult<AnalyticsSequence[]>> {
    let endpoint = `${environment.apiUrl}/analytics/sequences?`;

    if (campaignId) {
      endpoint += `&campaign_id=${campaignId}`;
    }

    if (fromAt) {
      endpoint += `&from=${fromAt}`;
    }

    if (toAt) {
      endpoint += `&to=${toAt}`;
    }

    return this.http.get<PaginatedResult<AnalyticsSequence[]>>(endpoint).pipe(take(1));
  }

  getFunnelPerformance(startDate: string, endDate: string, integrationId?: string): Observable<FunnelPerformanceResponse> {
    let endpoint = `${environment.apiUrl}/analytics/funnel-performance?start_date=${startDate}&end_date=${endDate}`;

    if (integrationId) {
      endpoint += `&integration_id=${integrationId}`;
    }

    return this.http.get<{data: FunnelPerformanceResponse}>(endpoint).pipe(
      map(res => res.data),
      take(1)
    );
  }

  getFunnelSequences(campaignId: string, startDate: string, endDate: string): Observable<FunnelSequencePerformanceItem[]> {
    const endpoint = `${environment.apiUrl}/analytics/funnel-performance/${campaignId}/sequences?start_date=${startDate}&end_date=${endDate}`;

    return this.http.get<{data: FunnelSequencePerformanceItem[]}>(endpoint).pipe(
      map(res => res.data),
      take(1)
    );
  }

  getSalesIndicator(integrationId: string = '', startDate: string, endDate: string): Observable<AnalyticsSales> {
    let endpoint = `${environment.apiUrl}/analytics/sales?start_date=${startDate}&end_date=${endDate}`;

    if (integrationId) {
      endpoint += `&integration_id=${integrationId}`;
    }

    return this.http.get<AnalyticsSales>(endpoint).pipe(take(1));
  }

  serialize(obj: any): string {
    var str = [];
    for (var p in obj) {
      if (obj.hasOwnProperty(p) && obj[p] != null) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }
    return str.join("&");
  }

  dateToIso(date: Date = null): string {
    if (!date) {
      return null;
    }

    const year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let day: any = date.getDate();

    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;

    return `${year}-${month}-${day}`;
  }

  isoToDate(date: string = null): Date {
    if (!date) {
      return null;
    }
    const parts = date.split('-');
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Meses em JavaScript são baseados em zero (0 = janeiro, 1 = fevereiro, etc.)
    const day = parseInt(parts[2], 10);
    return new Date(year, month, day);
  }

  isoToBr(date: string = null): string {
    if (!date) {
      return null;
    }

    return date.split('-').reverse().join('/');
  }
}
